// extracted by mini-css-extract-plugin
module.exports = {"loader-state":"checkbox-with-loader_loader-state__sZOlK","loader-icon":"checkbox-with-loader_loader-icon___YYWD"};